import { render, staticRenderFns } from "./ccgq.vue?vue&type=template&id=5db23e1d&"
import script from "./ccgq.vue?vue&type=script&lang=js&"
export * from "./ccgq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports